import { chevronLeft } from '@wordpress/icons';
import { useTranslate } from 'i18n-calypso';

import Sidebar from 'components/sidebar';
import { useNavigate } from 'react-router-dom';

export default function WPCloudSidebar() {
	const translate = useTranslate();
	const navigate = useNavigate();

	return (
		<Sidebar>
			<Sidebar.Navigator initialPath={ '/' }>
				<Sidebar.NavigatorMenu
					path={ '/' }
					title={ translate('WP Cloud') }
					description={ translate('Manage your WP Cloud partner account.') }
					backButtonProps={ {
						label: translate( 'Back to overview' ),
						icon: chevronLeft,
						onClick: () => {
							navigate( '/' );
						},
					} }
				/>
			</Sidebar.Navigator>
		</Sidebar>
	);
}
